import React, { useReducer, useState } from "react";
import "./personnel.scss";
import { Box, Divider, Skeleton, Tooltip } from "@mui/material";
import {
  AccountCircleRounded,
  ArrowBackRounded,
  CheckCircle,
  PeopleOutline,
  PictureAsPdfRounded,
  Print,
  Visibility,
} from "@mui/icons-material";
import { orderBy } from "lodash";

import { Link, useNavigate } from "react-router-dom";
import SearchBar from "../../component/searchBar/Search.tsx";
import { catchErrorApiCall } from "../../_services/apiUtils.js";
import { accountService } from "../../_services/accountServices.js";
import { PersonnelType, requestType } from "../../types/GlobalType.ts";
import toast from "react-hot-toast";
import { personnelContext } from "../../context/AppContext.js";
import { API_PERSONNEL } from "../../apiCaller/personnel.Caller.js";
import SinglePersonnel from "../configuration/personnel/singlePersonnel.tsx";
import ConnexionErrorDiv from "../../component/nodata/ConnexionErrorDiv.js";

const PersonnelList = () => {
  const [openSingle, setOpenSingle] = useState<Boolean>(false);

  const [searchValue, setSearchValue] = useState<string>("");

  const [stateReload, dispatchReload] = useReducer((x) => x + 1, 0);

  const navigate = useNavigate();

  const [dataPersonnel, setDataPersonnel] = useState<PersonnelType[]>([]);

  const [singleDataPersonnel, setsingleDataPersonnel] =
    useState<PersonnelType>();

  const [state, setState] = React.useState<requestType>({
    isLoading: false,
    errorMessage: false,
    successMessage: false,
  });

  const fetchAllPersonnel = async () => {
    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    try {
      const response = await API_PERSONNEL.PERSONNEL.getAll(token);
      setDataPersonnel(response.data.data);

      setState({ ...state, isLoading: false });
    } catch (error) {
      setState({ ...state, isLoading: false });

      if (error.code === "ERR_NETWORK") {
        return setState({
          isLoading: false,
          successMessage: false,
          errorMessage: "ERR_NETWORK",
        });
      }
      catchErrorApiCall(error);
    }
  };

  let sortedData: PersonnelType[] = [];
  if (dataPersonnel.length > 0) {
    sortedData = orderBy(dataPersonnel, ["nom"], ["asc"]);
  }

  const skeletonHeader = (
    <div className="configuration_">
      <Skeleton
        variant="rounded"
        height={25}
        width={250}
        sx={{ marginTop: "5px", marginRight: "10px" }}
      />
      <Skeleton
        variant="rounded"
        height={25}
        width={150}
        sx={{ marginTop: "5px", marginRight: "10px" }}
      />
    </div>
  );
  const skeletonSearchSection = (
    <div className="input-container">
      <Skeleton
        variant="rounded"
        height={30}
        width={250}
        sx={{ marginTop: "5px" }}
      />

      <div className="right_list_part">
        <Skeleton
          variant="rounded"
          height={30}
          width={"90%"}
          sx={{ marginTop: "5px" }}
        />
        <Skeleton
          variant="circular"
          height={30}
          width={30}
          sx={{ marginTop: "5px" }}
        />
      </div>
    </div>
  );
  const skeletonTable = (
    <Skeleton
      sx={{ marginTop: "10px" }}
      variant="rounded"
      height={500}
      width={"100%"}
    />
  );

  React.useEffect(() => {
    fetchAllPersonnel();
  }, [stateReload]);
  return (
    <>
      {state.errorMessage === "ERR_NETWORK" ? (
        <ConnexionErrorDiv />
      ) : (
        <Box
          bgcolor="#eee"
          flex={5}
          p={1}
          sx={{ marginLeft: "200px", marginTop: "66px" }}
        >
          {state.isLoading ? (
            skeletonHeader
          ) : (
            <div className="configuration_">
              <div className="homeMenuCong">
                <Link to="/">
                  <ArrowBackRounded
                    sx={{
                      color: "#0091EA",
                      backgroundColor: "#fff",
                      borderRadius: "50%",
                      mt: "5px",
                      cursor: "pointer",
                    }}
                  />
                </Link>
                <div className="homeTitleItem">
                  <Link to="/">
                    <span className="homeTitle"> Accueil </span>
                  </Link>
                </div>
                <div className="homeTitleItem">
                  <PeopleOutline sx={{ color: "#1565C0", mr: "10px" }} />
                  <span className="homeTitleSmall">Personnels </span>
                </div>
              </div>
              <div className="right__">
                <button className="add_button_pers">
                  <Tooltip title="Exporter PDF">
                    <PictureAsPdfRounded className="ico" />
                  </Tooltip>
                  exporter
                </button>
              </div>
            </div>
          )}

          <Divider sx={{ marginTop: "5px", marginBottom: "10px" }} />

          <div className="card_Classe">
            {state.isLoading ? (
              skeletonSearchSection
            ) : (
              <div className="input-container">
                <div className="leftTitle">
                  <h2 className="card-title">Liste</h2>
                </div>

                <div className="right_list_part">
                  <SearchBar
                    searchValue={searchValue}
                    setSearchValue={setSearchValue}
                    label="Rechercher..."
                  />
                  <button className="add_button_pers">
                    <Tooltip title="Imprimer">
                      <Print className="ico" />
                    </Tooltip>
                  </button>
                </div>
              </div>
            )}

            {state.isLoading ? (
              skeletonTable
            ) : (
              <div className="table_component" role="region">
                <table>
                  <thead>
                    <tr>
                      <th>Id</th>
                      <th>Noms</th>
                      <th className="">Genre</th>
                      <th>Fonction</th>
                      <th>Domaine</th>
                      <th className="headerSection">Status</th>
                      <th className="actionHeader"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {sortedData
                      .filter(
                        (value) =>
                          value.nom
                            ?.toLowerCase()
                            .includes(searchValue.toLowerCase()) ||
                          value.postnom
                            ?.toLowerCase()
                            .includes(searchValue.toLowerCase()) ||
                          value.prenom
                            ?.toLowerCase()
                            .includes(searchValue.toLowerCase()) ||
                          value.fonction_designation
                            ?.toLowerCase()
                            .includes(searchValue.toLowerCase()) ||
                          value.domaine_designation
                            ?.toLowerCase()
                            .includes(searchValue.toLowerCase())
                      )
                      .filter((value) => value.personnel_status == "1")
                      .map((item, index) => {
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td
                              className="userName"
                              onClick={() => {
                                setsingleDataPersonnel(item);
                                setOpenSingle(true);
                              }}
                            >
                              <div className="userName">
                                <AccountCircleRounded />
                                {`${item.nom?.toUpperCase()} ${item.postnom?.toUpperCase()} ${item.prenom?.toUpperCase()}`}
                              </div>
                            </td>
                            <td
                              onClick={() => {
                                setsingleDataPersonnel(item);
                                setOpenSingle(true);
                              }}
                            >
                              {item.sexe?.toLocaleUpperCase()}
                            </td>
                            <td
                              onClick={() => {
                                setsingleDataPersonnel(item);
                                setOpenSingle(true);
                              }}
                            >
                              {item.fonction_designation?.toLocaleUpperCase()}
                            </td>
                            <td
                              onClick={() => {
                                setsingleDataPersonnel(item);
                                setOpenSingle(true);
                              }}
                            >
                              {item.domaine_designation?.toLocaleUpperCase()}
                            </td>

                            <td className="statusSection">
                              <span>
                                <Tooltip title="Activé" placement="left">
                                  <CheckCircle
                                    style={{
                                      color: "#28a745",
                                      fontSize: "14px",
                                    }}
                                  />
                                </Tooltip>
                              </span>
                            </td>
                            <td>
                              <div className="actionSection">
                                <span className="more">
                                  <Visibility
                                    className="ico"
                                    onClick={() => {
                                      setsingleDataPersonnel(item);
                                      setOpenSingle(true);
                                    }}
                                  />
                                </span>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </Box>
      )}

      {openSingle && (
        <personnelContext.Provider value={singleDataPersonnel}>
          {/* Here we dont care about account of personnal, it means only in configuration   */}
          <SinglePersonnel
            dispatchReload={dispatchReload}
            setOpen={setOpenSingle}
            accountExists={undefined}
          />
        </personnelContext.Provider>
      )}
    </>
  );
};

export default PersonnelList;
